import React from 'react'
import Box from '@material-ui/core/Box'
import LessonPacksList from './lesson-packs-list'
import SectionEmptyState from 'components/section-empty-state'
import CalendarTodayIcon from 'components/material-symbol/icons/CalendarToday'
import { useStyles } from './styles'

const LessonPacks = ({ lessonPacks, refetch }) => {
  const classes = useStyles()

  const activeLessonPacks = lessonPacks.filter(
    lp =>
      lp.remainingCredits > 0 &&
      (lp.expiresAt === null || Date.parse(lp.expiresAt) > Date.now()),
  )

  const usedOrExpiredLessonPacks = lessonPacks.filter(
    lp => lp.remainingCredits === 0 || Date.parse(lp.expiresAt) < Date.now(),
  )

  if (lessonPacks.length === 0) {
    return (
      <Box className={classes.lessonPacksEmptyState}>
        <SectionEmptyState
          Icon={CalendarTodayIcon}
          title="No Lesson Packs"
          caption="This student hasn't purchased any lesson packs."
          bordered={false}
        />
      </Box>
    )
  }

  return (
    <Box className={classes.lessonPacksContent}>
      <LessonPacksList
        title="Active"
        lessonPacks={activeLessonPacks}
        refetch={refetch}
      />
      <LessonPacksList
        title="Inactive / Expired"
        lessonPacks={usedOrExpiredLessonPacks}
        refetch={refetch}
      />
    </Box>
  )
}
export default LessonPacks
